var centerInfo = function () {
  $('.location_item > span').on('click', function () {
    if ($(window).width() > 570) {
      $('.location_item__pop-up').fadeOut().css('left', '50%')
      var $infoWindow = $(this).siblings('.location_item__pop-up')
      $infoWindow.fadeIn()
      setTimeout(function () {
        var infoPositionLeft = $infoWindow.offset().left,
          infoPositionRight =
            $infoWindow.offset().left + $infoWindow.outerWidth(true)
        if (infoPositionLeft <= 0) {
          $infoWindow.css('left', Math.abs(infoPositionLeft))
        } else if (infoPositionRight > $(window).width()) {
          $infoWindow.css('left', $(window).width() - infoPositionRight)
        }
      }, 400)
    }
  })
}

$(document).ready(function () {
  $(document).mouseup(function (e) {
    var container = $('.location_item__pop-up')

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.fadeOut().css('left', '50%')
    }
  })
  centerInfo()
})
